import {
  ArrowLeftRight, BadgePercent, Banknote, BookOpenText, ClipboardCheck, Workflow, Briefcase, Building2, CalendarClock, ChartLine, ClipboardList, Contact, CreditCard,
  FileCheck2, FileSignature, FileText, FolderKanban, FolderOpen, Gauge, GitBranch, HandCoins, Handshake, Headset, KeyRound, Landmark, LayoutDashboard,
  KanbanSquare, LayoutGrid, Receipt, LineChart, ListTodo, Mail, MapPinned, MessageSquare, MonitorPlay, Percent, PieChart, Puzzle, RefreshCcw,
  Scale, ScrollText, Server, Settings, ShieldCheck, ShoppingBag, Tags, TrendingUp, UserCog, UserRound, Users, Target, UserCheck, UserRoundCheck, UsersRound, Wallet, type LucideIcon,
} from 'lucide-react'
import type { PermissionCheck } from '@/lib/auth/permissions'

/** `match` verilirse aktiflik buna göre hesaplanır (alt sayfaları olan menüler için). */
export type NavItem = { key: string; to: string; icon: LucideIcon; perm?: PermissionCheck; match?: (pathname: string) => boolean }
export type NavGroup = { key: string; icon: LucideIcon; items: NavItem[] }

export const NAV: NavGroup[] = [
  { key: 'overview', icon: LayoutDashboard, items: [{ key: 'dashboard', to: '/', icon: Gauge }] },
  {
    key: 'mail',
    icon: Mail,
    items: [{ key: 'mailbox', to: '/mail', icon: Mail, perm: 'mail:user:read' }],
  },
  {
    key: 'customers',
    icon: Handshake,
    items: [
      { key: 'crmOverview', to: '/customers', icon: Gauge, perm: 'crm:account:read', match: (p) => p === '/customers' },
      { key: 'crmCustomers', to: '/customers/list', icon: Users, perm: 'crm:account:read', match: (p) => p === '/customers/list' || /^\/customers\/(?!list$|offers$|orders$|renewals$|followups$|meetings$|expenses$|delivery$|collections$|support$|access$)[^/]+/.test(p) },
      { key: 'crmFollowups', to: '/customers/followups', icon: ListTodo, perm: 'crm:account:read' },
      { key: 'crmOffers', to: '/customers/offers', icon: FileSignature, perm: 'sales:quote:read' },
      { key: 'crmOrders', to: '/customers/orders', icon: ShoppingBag, perm: 'sales:order:read' },
      { key: 'crmRenewals', to: '/customers/renewals', icon: RefreshCcw, perm: 'renewals.write' },
      { key: 'crmMeetings', to: '/customers/meetings', icon: MessageSquare, perm: 'crm:meeting:read' },
      { key: 'crmExpenses', to: '/customers/expenses', icon: Receipt, perm: ['crm:expense:create', 'crm:expense:read_all', 'crm:expense:approve'] },
      { key: 'crmDelivery', to: '/customers/delivery', icon: MonitorPlay, perm: 'accounts.read' },
      { key: 'crmCollections', to: '/customers/collections', icon: Wallet, perm: 'crm:finance:read' },
      { key: 'crmSupport', to: '/customers/support', icon: Headset, perm: 'tickets.write' },
      { key: 'crmAccess', to: '/customers/access', icon: KeyRound, perm: 'crm:account:read' },
    ],
  },
  {
    key: 'projects',
    icon: FolderOpen,
    items: [
      {
        key: 'projectBoards',
        to: '/projects/boards',
        icon: LayoutGrid,
        perm: 'tasks.write',
        match: (p) => p.startsWith('/projects/') && !p.startsWith('/projects/catalog') && !p.startsWith('/projects/rules') && !p.startsWith('/projects/tasks') && !p.startsWith('/projects/assignment-requests'),
      },
      { key: 'projectTasks', to: '/projects/tasks', icon: KanbanSquare, perm: 'tasks.write' },
      { key: 'projectAssignments', to: '/projects/assignment-requests', icon: UserRoundCheck, perm: 'tasks.write' },
      { key: 'projectRules', to: '/projects/rules', icon: Workflow, perm: ['tasks.boards.manage', 'tasks.assign'] },
      { key: 'projectCatalog', to: '/projects/catalog', icon: Puzzle, perm: 'catalog:module:read' },
    ],
  },
  {
    key: 'hr',
    icon: UsersRound,
    items: [
      { key: 'hrPersonel', to: '/hr/personel', icon: Users, perm: 'hr.core:employee:read' },
      { key: 'hrBelgeler', to: '/hr/belgeler', icon: FileText, perm: 'documents:catalog:read', match: (p) => p === '/hr/belgeler' || p.startsWith('/hr/belgeler/sablonlar') },
      { key: 'hrBelgeTakip', to: '/hr/belgeler/takip', icon: ClipboardCheck, perm: ['documents:employee:review', 'documents:employee:followup'] },
      { key: 'hrBordro', to: '/hr/bordro', icon: Wallet, perm: 'hr.payroll:payroll:read' },
      { key: 'hrOdemeler', to: '/hr/odemeler', icon: CreditCard, perm: 'hr.payroll:payment:read' },
      { key: 'hrPositions', to: '/hr/pozisyonlar', icon: Briefcase, perm: 'hr.org:position:read' },
      { key: 'departments', to: '/hr/departmanlar', icon: Building2, perm: 'hr.org:department:read' },
    ],
  },
  // {
  //   key: 'licensing',
  //   icon: BadgeCheck,
  //   items: [
  //     { key: 'installations', to: '/installations', icon: Server, perm: 'accounts.read' },
  //     { key: 'licenses', to: '/licenses', icon: KeyRound, perm: 'licenses.issue' },
  //     { key: 'releases', to: '/releases', icon: PackageCheck, perm: 'releases.write' },
  //   ],
  // },
  // {
  //   key: 'printers',
  //   icon: Printer,
  //   items: [
  //     { key: 'printers', to: '/printers', icon: Printer, perm: ['printers.read', 'printers.manage', 'settings.write'], match: (p) => p === '/printers' },
  //     { key: 'printerInstalls', to: '/printers/installations', icon: ClipboardList, perm: ['printers.read', 'printers.manage', 'settings.write'] },
  //   ],
  // },
  {
    key: 'insights',
    icon: ChartLine,
    items: [
      { key: 'reportOverview', to: '/reports', icon: Gauge, perm: 'reports.read', match: (p) => p === '/reports' },
      { key: 'reportSales', to: '/reports/sales', icon: TrendingUp, perm: 'reports.read' },
      { key: 'reportOperations', to: '/reports/operations', icon: FolderKanban, perm: 'reports.read' },
      { key: 'reportProfitability', to: '/reports/profitability', icon: PieChart, perm: 'finance:ledger:read' },
    ],
  },
  {
    key: 'finance',
    icon: Landmark,
    items: [
      { key: 'financeOverview', to: '/finance', icon: PieChart, perm: 'finance:ledger:read', match: (p) => p === '/finance' },
      { key: 'financeAccounts', to: '/finance/accounts', icon: Wallet, perm: 'finance:account:read' },
      { key: 'financeCards', to: '/finance/cards', icon: CreditCard, perm: 'finance:account:read' },
      { key: 'financeTransactions', to: '/finance/transactions', icon: ArrowLeftRight, perm: 'finance:ledger:read' },
      { key: 'financeObligations', to: '/finance/obligations', icon: CalendarClock, perm: 'finance:obligation:read' },
      { key: 'financeLoans', to: '/finance/loans', icon: HandCoins, perm: 'finance:loan:read' },
      { key: 'financeReimbursements', to: '/finance/reimbursements', icon: Wallet, perm: 'finance:reimbursement:read' },
      { key: 'financeStaffAdvances', to: '/finance/staff-advances', icon: HandCoins, perm: 'finance:staff_advance:read' },
      { key: 'financeCashAdvances', to: '/finance/cash-advances', icon: Banknote, perm: 'finance:cash_advance:read' },
      { key: 'financeParties', to: '/finance/parties', icon: Contact, perm: 'finance:party:read' },
      { key: 'financeDeposits', to: '/finance/deposits', icon: Percent, perm: 'finance:deposit:read' },
      { key: 'financeFx', to: '/finance/fx', icon: TrendingUp, perm: ['finance:account:read', 'finance:fx_rate:manage', 'finance:fx:revalue'] },
      { key: 'financePnL', to: '/finance/pnl', icon: Scale, perm: 'finance:report:pnl' },
      { key: 'financeBudgets', to: '/finance/budgets', icon: Target, perm: 'finance:budget:read' },
      { key: 'financeDepartments', to: '/finance/departments', icon: Building2, perm: 'finance:department:assign' },
      { key: 'financeBankReport', to: '/finance/bank-report', icon: ChartLine, perm: 'finance:report:bank' },
      { key: 'financeCashFlow', to: '/finance/cash-flow', icon: LineChart, perm: 'finance:ledger:read' },
      { key: 'financeBooks', to: '/finance/books', icon: BookOpenText, perm: 'finance:gl:read' },
      { key: 'financeBanks', to: '/finance/banks', icon: Building2, perm: 'finance:bank:manage' },
      { key: 'financeCategories', to: '/finance/categories', icon: Tags, perm: 'finance:category:manage' },
      { key: 'financeEDocs', to: '/finance/e-documents', icon: FileCheck2, perm: 'finance:edoc:read' },
      // İptal talebi açabilen herkes kendi taleplerini; onaycılar tümünü görür.
      { key: 'financeApprovals', to: '/finance/approvals', icon: ShieldCheck, perm: ['finance:void:approve', 'finance:void:owner_approve', 'finance:ledger:write', 'finance:payment:write', 'finance:obligation:manage'] },
      { key: 'financePaymentRequests', to: '/finance/payment-requests', icon: ClipboardCheck, perm: ['finance:payment_request:create', 'finance:payment_request:read', 'finance:payment_request:approve'] },
      { key: 'financePersonal', to: '/finance/personal', icon: UserRound, perm: 'finance:personal:use' },
    ],
  },
  {
    key: 'admin',
    icon: Settings,
    items: [
      { key: 'tax', to: '/admin/tax', icon: Percent, perm: 'finance:tax:read' },
      { key: 'pipelines', to: '/admin/pipelines', icon: GitBranch, perm: 'pipelines.manage' },
      { key: 'discounts', to: '/admin/discounts', icon: BadgePercent, perm: 'sales:discount:manage' },
      { key: 'customerCategories', to: '/admin/customer-categories', icon: Tags, perm: 'crm:category:manage' },
      { key: 'regions', to: '/admin/regions', icon: MapPinned, perm: 'settings.write' },
      { key: 'mail', to: '/admin/mail', icon: Mail, perm: 'mail:account:manage' },
      { key: 'infra', to: '/admin/infra', icon: Server, perm: ['infra.servers.read', 'infra.servers.write'] },
      { key: 'audit', to: '/admin/audit', icon: ScrollText, perm: 'audit:read' },
    ],
  },
  {
    key: 'access',
    icon: UserCheck,
    items: [
      { key: 'accessUsers', to: '/access/users', icon: Users, perm: 'identity:user:read' },
      { key: 'accessRoles', to: '/access/roles', icon: UserCog, perm: 'identity:role:read' },
    ],
  },
]

export function visibleNav(can: (p: PermissionCheck) => boolean): NavGroup[] {
  return NAV.map((g) => ({ ...g, items: g.items.filter((i) => can(i.perm)) })).filter((g) => g.items.length > 0)
}

export const NAV_ICON_FALLBACK = ClipboardList
